const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://40gg9oivq4.execute-api.ap-southeast-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://op4x5ydegc.execute-api.ap-southeast-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.ozminerals.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.ozminerals.forwoodsafety.com',
    WEBSOCKET: 'wss://wg3taxg1u2.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;
